import React from 'react';

import { BitbucketIcon, BitbucketLogo } from '@atlaskit/logo';

import LogoTable from '../utils/logo-table';

export default (): React.JSX.Element => (
	<LogoTable
		logo={<BitbucketLogo appearance="brand" />}
		icon={<BitbucketIcon appearance="brand" />}
	/>
);
